export const hideHeaderRoutes = [
  "/insider-form",
  "/login",
  "/forgot-password",
  "/forgot-username",
  "/show-username",
  "/forgotten-user-id",
  "/check-email",
  "/confirmed-new-link",
  "/confirmed-new-invite",
  "/portal/selection",
  "/store-selection",
  "/change-password",
  "/mfa-verification",
  "/password-changed-success",
  "/unauthorized",
  "/system-maintenance"
];

const normalizeRoutePath = (route) => {
  if (!route || typeof route !== "string") {
    return "";
  }
  let normalized = route;
  const hashIndex = normalized.indexOf("#");
  if (hashIndex !== -1) {
    normalized = normalized.substring(0, hashIndex);
  }
  const queryIndex = normalized.indexOf("?");
  if (queryIndex !== -1) {
    normalized = normalized.substring(0, queryIndex);
  }
  if (normalized.length > 1 && normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }
  return normalized;
};

const hasCrossAppLoginQuery = (route) => {
  if (!route || typeof route !== "string") {
    return false;
  }
  try {
    const url = new URL(route, window.location.origin);
    const loginRequired = url.searchParams.get("loginRequired");
    const moveDirect = url.searchParams.get("moveDirect");
    if (loginRequired === "true" || moveDirect === "true") {
      return true;
    }
  } catch (error) {
    const lowered = route.toLowerCase();
    if (lowered.includes("loginrequired=true") || lowered.includes("movedirect=true")) {
      return true;
    }
  }
  return false;
};

export const isRouteHidden = (route) => {
  if (!route || typeof route !== "string") {
    return false;
  }
  if (hasCrossAppLoginQuery(route)) {
    return true;
  }
  const normalized = normalizeRoutePath(route);
  return hideHeaderRoutes.includes(normalized);
};

